import { useEffect, useState } from 'react';

import { getWindow } from '@change-corgi/core/window';

import { useIsVenmoQREnabled, usePaypal } from 'src/app/shared/hooks/payments';
import { isLoaded } from 'src/app/shared/utils/async';

export function useCanUseVenmo(): boolean {
	const paypal = usePaypal();
	const [canUseVenmo, setCanUseVenmo] = useState(false);

	const isVenmoQrEnabled = useIsVenmoQREnabled();

	useEffect(() => {
		(async function init() {
			if (isLoaded(paypal) && !canUseVenmo) {
				const venmoInstance = await getWindow().braintree.venmo.create({
					client: paypal.braintreeClientInstance,
					allowDesktop: isVenmoQrEnabled,
					allowNewBrowserTab: false,
				});
				setCanUseVenmo(venmoInstance.isBrowserSupported());
				void venmoInstance.teardown();
			}
		})();
	}, [paypal, canUseVenmo, isVenmoQrEnabled]);
	return canUseVenmo;
}
